/* eslint-disable @typescript-eslint/ban-ts-comment */
export function universalGetItem(key: string) {
  return window.localStorage.getItem(key);
}

export function universalSetItem(key: string, value: string) {
  window.localStorage.setItem(key, value);
}
